import { getGamesListKey } from '@/helpers/gamesCurrencies';
import type {
  CommonStoreType,
  GamesByParameterData,
  IGamesInfo,
} from '@/store/commonStore/types';
import { selectIsAwaitingWallets } from './selectIsAwaitingWallets';

export type GamesListSource = 'category' | 'provider';

interface IGamesListCache {
  lists: GamesByParameterData;
  pending: Record<string, boolean>;
}

const GAMES_LIST_CACHES: Record<
  GamesListSource,
  (state: CommonStoreType) => IGamesListCache
> = {
  category: (state) => ({
    lists: state.gamesByCategories,
    pending: state.pendingGamesByCategories,
  }),
  provider: (state) => ({
    lists: state.gamesByProviders,
    pending: state.pendingGamesByProviders,
  }),
};

export interface IGamesListState {
  key: string;
  list?: IGamesInfo;
  isPending: boolean;
  isAwaitingWallets: boolean;
}

export const selectGamesList =
  (source: GamesListSource, param: string, subName?: string) =>
  (state: CommonStoreType): IGamesListState => {
    const key = getGamesListKey(state, param, subName);
    const { lists, pending } = GAMES_LIST_CACHES[source](state);

    return {
      key,
      list: lists[key],
      isPending: Boolean(pending[key]),
      isAwaitingWallets: selectIsAwaitingWallets(state),
    };
  };
